import api from '../../config/axios.js';
import moment from 'moment';
import 'moment/dist/locale/pt-br';
moment.locale('pt-br');

let serviceListRequestId = 0;

const state = {
    serviceList: [],
    searchedServices: [],
    servicesPagination: {},
    currentService: null,
    currentUpdateService: null,
    currentDeleteService: null
}
const getters = {
    getServiceList: state => state.serviceList,
    getSearchedServices: state => state.searchedServices,
    getServicesPagination: state => state.servicesPagination,
    getCurrentService: state => state.currentService,
    getCurrentUpdateService: state => state.currentUpdateService,
    getCurrentDeleteService: state => state.currentDeleteService,
}
const actions = {
    // BUSCANDO DADOS FINANCEIROS
    async fetchServiceList({ commit }, filters = 1){
        const params = typeof filters === 'object' ? { ...filters } : { page: filters };
        params.page = params.page || 1;
        if (params.category_id === '') delete params.category_id;

        const requestId = ++serviceListRequestId;
        const response = await api.axios.get('/api/service/list', { params });
        if (requestId === serviceListRequestId && response && response.data) {
            commit("fetchServiceList", response.data);
        }
    },
    async setSearchServicesList({ commit }, query){
        try {
            const response = await api.axios.get(`/api/service/search/${encodeURIComponent(query)}`);
            commit('setSearchServicesList', response.data || []);
        } catch (error) {
            if (error.response && error.response.status === 404) {
                commit('setSearchServicesList', []);
                return;
            }
            console.error('Erro ao pesquisar serviços:', error);
            commit('setSearchServicesList', []);
        }
    },
    // DEFININDO SERVIÇO ATUAL
    setCurrentService({ commit }, service){
        commit("setCurrentService", service);
    },
    //DEFININDO SERVIÇO ATUAL A SER ATUALIZADO
    setCurrentUpdateService({ commit }, service){
        commit("setCurrentUpdateService", service);
    },
    // DEFININDO SERVIÇO ATUAL A SER DELETADO
    setCurrentDeleteService({ commit }, expense){
        commit("setCurrentDeleteService", expense);
    }
}

const mutations = {
    fetchServiceList: function(state, data){
        if (data && data.data !== undefined) {
            state.serviceList = data.data;
            state.servicesPagination = data;
        } else {
            state.serviceList = data;
            state.servicesPagination = {};
        }
    },
    setSearchServicesList: function(state, data){
        state.searchedServices = data;
    },
    setCurrentService: function(state, data){
        state.currentService = data;
    },
    setCurrentUpdateService: function(state, data){
        state.currentUpdateService = data;
    },
    setCurrentDeleteService: function(state, data){
        state.currentDeleteService = data;
    }
}
export default {
    state,
    getters,
    actions,
    mutations
}
